"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _textareaModule = _interopRequireDefault(require("./textarea.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Textarea = function Textarea(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? undefined : _ref$defaultValue,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? undefined : _ref$placeholder,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? null : _ref$maxLength,
    _ref$minLength = _ref.minLength,
    minLength = _ref$minLength === void 0 ? null : _ref$minLength,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'on' : _ref$autoComplete,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$ariaInvalid = _ref.ariaInvalid,
    ariaInvalid = _ref$ariaInvalid === void 0 ? undefined : _ref$ariaInvalid,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? undefined : _ref$ariaLabel,
    _ref$ariaDescribedBy = _ref.ariaDescribedBy,
    ariaDescribedBy = _ref$ariaDescribedBy === void 0 ? undefined : _ref$ariaDescribedBy,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$characterCountVi = _ref.characterCountVisible,
    characterCountVisible = _ref$characterCountVi === void 0 ? false : _ref$characterCountVi,
    _ref$extensionProps = _ref.extensionProps,
    extensionProps = _ref$extensionProps === void 0 ? {} : _ref$extensionProps;
  var _useState = (0, _react.useState)((value === null || value === void 0 ? void 0 : value.length) || 0),
    _useState2 = _slicedToArray(_useState, 2),
    inputLength = _useState2[0],
    setInputLength = _useState2[1];
  var inputRef = (0, _react.useRef)(null);
  var valueProp = defaultValue === undefined ? {
    value: value
  } : {
    defaultValue: defaultValue
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", _objectSpread(_objectSpread(_objectSpread({
      id: id,
      name: name,
      className: (0, _classnames["default"])(_textareaModule["default"]['c-textarea'], className)
    }, valueProp), {}, {
      onChange: function onChange(e) {
        var _e$target;
        setInputLength(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.value) === null || _e$target === void 0 ? void 0 : _e$target.length);
        _onChange(e);
      },
      defaultValue: defaultValue,
      onFocus: onFocus,
      onBlur: onBlur,
      placeholder: placeholder,
      maxLength: maxLength,
      autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
      ,
      autoComplete: autoComplete,
      readOnly: readOnly,
      "aria-invalid": ariaInvalid,
      "aria-label": ariaLabel,
      "aria-describedby": ariaDescribedBy,
      disabled: disabled,
      ref: inputRef
    }, extensionProps), {}, {
      "data-jlds": true,
      "data-testid": "text-area"
    })), characterCountVisible || minLength ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_textareaModule["default"]['c-container']),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: "min-c-count-test",
        className: (0, _classnames["default"])(_textareaModule["default"]['c-min-characters'], className),
        "data-testid": "text-area-character-count-minimum",
        children: inputLength >= minLength ? null : "Minimum ".concat(minLength, " characters")
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        id: "c-count-test",
        className: (0, _classnames["default"])(_textareaModule["default"]['c-character-count'], className),
        "data-testid": "text-area-character-count",
        children: [characterCountVisible && maxLength ? "".concat(inputLength, "/").concat(maxLength) : null, characterCountVisible && !maxLength ? "".concat(inputLength) : null]
      })]
    }) : null]
  });
};
Textarea.propTypes = {
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  defaultValue: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  maxLength: _propTypes["default"].number,
  minLength: _propTypes["default"].number,
  autoFocus: _propTypes["default"].bool,
  autoComplete: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  ariaInvalid: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  ariaDescribedBy: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  characterCountVisible: _propTypes["default"].bool,
  extensionProps: _propTypes["default"].objectOf(_propTypes["default"].any)
};
var _default = exports["default"] = Textarea;